import { Component, OnInit, OnDestroy, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';
import { StaticContentService } from '../../modules/static-content/static-content.service';
import { AppUtilService } from '../../../app/core/utils/app-util.service';
import { BUID, CacheConstant, CacheDuration, CMSPages, CMSTemplateNames, UserDeviceConstant } from '../../../app/core/constants/app.constant';
import { ProductRoutes, OktaRoutes } from '../../../app/core/constants/routes.constant';
import { AppCacheService } from '../../core/services/cache/app-cache.service';
import { CmsService } from '../../core/services/cms.service';
import { MultipleCarousel, CallToAction, MultipleCallToAction, CmsContent, CmsContentField, StaticPageContent,ContentStructureDetails } from '../../shared/models/cms';
import * as _ from 'lodash';
import { DomSanitizer } from '@angular/platform-browser';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { GenericPopupComponent } from '../../modules/cms/generic-popup/generic-popup.component';
import { Subscription } from 'rxjs';
import { AddPopupComponent } from '../../modules/cms/add-popup/add-popup.component';
import { SalePopupComponent } from '../../modules/cms/sale-popup/sale-popup.component';
import { ProductsService } from '../../modules/products/products.service';
import { ProductHistoryDetails } from '../../shared/models/product';
import { BaseComponent } from '../../app.base.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfigService } from '../../core/services/init/app-config.service';
import { GoogleAnalyticsService } from '../../core/services/google-analytics.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent extends BaseComponent implements OnInit, OnDestroy {
  homePageData: {
    ctaData: any[]
  }

  slidesdata: any[] = [{}, {}, {}]

  slidesData: any[] = [];
  productCatlogs = {
    show: false,
    catalogs: []
  };

  slideIndex = 0;
  cmsSlideIndex = 0
  slides: HTMLCollectionOf<HTMLElement>;
  dots: HTMLCollectionOf<HTMLElement>;
  slideClick: boolean = false;
  businessManagedAlert: string = '';
  authenticatedBusinessAlert: string;
  isAuthenticated:boolean = false;
  pwdExpiring:boolean = false;
  
  cmsData: any;
  envProperties =  this.cache.get(CacheConstant.Env_Properties);
  pwdStatus = AppUtilService.cache.get(CacheConstant.Pwd_Dtl);
  //cmsContentFlag = this.envProperties.cmsContentFlag ? this.envProperties.cmsContentFlag.toBoolean() : false;
  timeOutIDs:any[] = [];
  cmsPageName: any;
  templateNum: any;
  ctaPageName: any;
  ctaTemplateNum: any;
  sequenceNo: number;
  carousel: MultipleCarousel = null;
  callToAction: MultipleCallToAction = null;
  buId = this.envProperties.buId;
  websiteName = this.envProperties.theme;
  cmsSlides: HTMLCollectionOf<HTMLElement>;
  cmsDots: HTMLCollectionOf<HTMLElement>;
  callToActionArrays: any;
  contentArr: any[];
  hyperLinkID: String;
  homePageGenericPopup: CmsContent;
  activeRouteSubscription: Subscription;
  homePageAdPopups: CmsContent[];
  homePageSalePopup: CmsContent;
  onSaleItems: ProductHistoryDetails[] = new Array<ProductHistoryDetails>();
  filteredHomePageAdPopUps: CmsContent[] = [];
  staticData:any[] = [];
  homepageImageContent: any[] = [];
  callToActionMajor: any[] = [];
  staticContent: any;
  homepageimage: string;
  imageContentArr: any[] = [];
  homePageResponseHeader:any;
  homePageResponseCta:any;
  staticBottomContent:any;
  content: any[];
  isDownloadProduct:boolean=false;
  selectedRole:string|null=null;
  searchBarDisabled: boolean = true;
  catalogFilterBy: string = null;
  productRadioButton: any;
  isHidden: boolean = false;
  showCurrentCustomer: boolean = false;
  downloadCatalog: boolean = false;
   activeCategory:string|null=null;
  categories=[
  ]
  productsHideOrShow: boolean = true;
  constructor(
    private router: Router,
    private staticContentService: StaticContentService,
    private authService: AuthService,
    private cache: AppCacheService,
    private cmsService: CmsService,
    private sanitizer: DomSanitizer,
    private elementRef: ElementRef,
    private renderer: Renderer2,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private productService: ProductsService, 
   deviceDetectorService: DeviceDetectorService,
    private appConfig: AppConfigService,
      private gAnalytics: GoogleAnalyticsService,
      private scroll:ViewportScroller,
) {
    super(deviceDetectorService, cache, appConfig);}

  ngOnInit() {
    this.isAuthenticated = this.authService.isAuthenticated();
    if(this.websiteName =='Major')
    this.getHomePageMajorWebsiteData();
    this.getHomepgeMaintenanceMsg();
    this.getCmsContent();
    this.getCTAContent();
    this.renderHtmlContent();
    if (this.isAuthenticated) {
      this.activeRouteSubscription = this.route.data.subscribe(
        (data) => {
          this.onRouteDataChange(data);
        }
      );
    }
  }
  
  private onRouteDataChange(data: any) {
    if (data) {
      const genericPopups = data.genericPopups;
      this.homePageGenericPopup = this.cmsService.prepareGenericPoupData(
        genericPopups);
      const adPopups = data.adPopups;
      this.homePageAdPopups = this.cmsService.prepareAdPoupData(adPopups);
      const salePopups = data.salePopup
      this.homePageSalePopup = this.cmsService.prepareSalePoupData(salePopups);
    }
  }

  ngAfterViewInit() {
    const showPopup = this.cache.get(CacheConstant.ShowPopup);
    if (showPopup === undefined && this.isAuthenticated && this.pwdStatus !== 'expired') {
      setTimeout(() => {
        this.cache.set(CacheConstant.ShowPopup, true);
        if (this.homePageSalePopup && this.cache.get(CacheConstant.SalePopUp) && this.buId === 1) {
          this.productService.getItemsOnSaleFromProductHistoryDetails().subscribe((response: any) => {
            if (response && !response.hasError) {
              this.onSaleItems = response;
              this.openSalePopupDialog();
            } else if (this.homePageGenericPopup) {
              this.openGenericPopup();
            } else if (this.homePageAdPopups) {
              this.openAdPopupDialog();
            }
          });
        } else if (this.homePageGenericPopup) {
          this.openGenericPopup();
        } else if (this.homePageAdPopups) {
          this.openAdPopupDialog();
        }
      }, 0);
    }
  }

  ngOnDestroy() {
    this.timeOutIDs.forEach(id => clearTimeout(id));
    if (this.isAuthenticated && this.activeRouteSubscription !== null) {
      this.activeRouteSubscription.unsubscribe();
    }
  }

  currentSlide(n) {
    this.slideClick = true;
    this.showSlides(n);
  }
  
  private openGenericPopup(): void {
    const dialogRef = this.dialog.open(GenericPopupComponent, {
      width: '870px',
      data: this.homePageGenericPopup,
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'close') {
        if (this.homePageAdPopups.length > 0) {
          this.openAdPopupDialog();
        } else {
          this.cmsService.isFromFeaturedItems.next(false);
        }
      }
    });
  }

  private openAdPopupDialog(): void {
    if (this.homePageAdPopups.length > 0) {
      this.homePageAdPopups = _.orderBy(
        this.homePageAdPopups,
        [CmsContentField.RowUpdateStamp],
        'desc'
      );
      this.homePageAdPopups = this.removeDuplicates(this.homePageAdPopups, [
        CmsContentField.sequenceNum,
      ]);
      this.homePageAdPopups = _.orderBy(
        this.homePageAdPopups,
        [CmsContentField.sequenceNum],
        'desc'
      );
      this.filteredHomePageAdPopUps = this.homePageAdPopups;
      if (this.filteredHomePageAdPopUps.length > 0) {
        this.filteredHomePageAdPopUps.forEach((adPopup: CmsContent) => {
          const dialogRef = this.dialog.open(AddPopupComponent, {
            width: '870px',
            data: adPopup,
            disableClose: true,
          });
          dialogRef.afterClosed().subscribe((result) => {
            if (result === 'close') {
              this.cmsService.isFromFeaturedItems.next(false);
            }
          });
        });
      }
    }
  }

  private removeDuplicates(arrayList, prop) {
    return arrayList.filter((obj, pos, arr) => {
      return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
  }
  
  showSlides(n = -1) {
    if (n === -1 && this.slideClick) {
      this.slideClick = false;
      return;
    }

    for (let i = 0; i < this.slides.length; i++) {
      this.slides[i].style.display = "none";
      this.dots[i].className = this.dots[i].className.replace(" active", "");
    }
    if (n > -1) {
      this.slideIndex = n;
    }
    this.slideIndex++;
    if (this.slideIndex > this.slides.length) {
      this.slideIndex = 1
    }
   if(this.slides.length>0){
    this.slides[this.slideIndex-1].style.display = "block";
    this.dots[this.slideIndex-1].className += " active";
   }
   
    this.timeOutIDs.push(
    setTimeout(() => this.showSlides(), 6000)
    );
  }

  carouselClick(route) {
    if (route) {
      this.router.navigate([route]);
    }
  }

  ctaClick(i: number, cmsContentLinkObj: any) {
    // if(this.cmsContentFlag === false){
    //   if (this.homePageData.ctaData[i].link) {
    //     window.open(this.homePageData.ctaData[i].link, "_blank");
    //   }

    //   if (this.homePageData.ctaData[i].route) {
    //     if (this.homePageData.ctaData[i].route == ProductRoutes.ProductCatalog) {
    //       this.getProductCatalogsForShop();
    //     } else {
    //       this.router.navigate([this.homePageData.ctaData[i].route]);
    //     }
    //   }
    // }else{
    //   this.navigateToTargetLink(cmsContentLinkObj);
    //
    // }
    this.navigateToTargetLink(cmsContentLinkObj);
  }

  getHomepgeMaintenanceMsg() {
    if(this.isMobileDevice() && this.websiteName == 'Major'){
      this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
    }
    else
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.userNotificAuthenticatedSeqNo : this.envProperties.cmsPageConfigVO.userNotificUnauthenticatedSeqNo;
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, pageSeqNumber).subscribe((response: any) => {

      if (!response.hasError && response.length > 0) {
              this.content = response
              this.content.filter((maintenancemsg)=>{
                // if (maintenancemsg.contentName == "Major Notification Un-Authenticated User") {
                  let staticPageContent: StaticPageContent = maintenancemsg;
                    this.businessManagedAlert = this.cmsService.prepareNotificMsg(staticPageContent);
                  //  }
              })
            } 
  })
}

  getHomePageMajorWebsiteData() {
    if(this.isMobileDevice() && this.websiteName == 'Major'){
      this.cmsPageName = this.isAuthenticated ? CMSPages.Mobile_Home : CMSPages.Mobile_Login;
    }
    else
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.home : this.envProperties.cmsPageConfigVO.home;
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum, pageSeqNumber).subscribe((response: any) => {

      if (!response.hasError && response.length > 0) {
              this.content = response
              this.content.filter((maintenancemsg)=>{
                if (maintenancemsg.contentName == "Major Notification Un-Authenticated User") {
                  let staticPageContent: StaticPageContent = maintenancemsg;
                    this.businessManagedAlert = this.cmsService.prepareNotificMsg(staticPageContent);
                   }
              })
               
              this.content.forEach((cta: CmsContent) => {
              cta.contentStructure = JSON.parse(cta.contentStructure);
           
            });
              this.content.sort((a, b) => b.contentNum - a.contentNum);
              this.content.forEach((cta: any, i) => {
                if (cta.contentName == CMSTemplateNames.Web_HomePage +" 1"  || cta.contentName == CMSTemplateNames.Mobile_HomePage +" 1" )
                   {
                  this.homePageResponseHeader = cta.contentStructure.recordList;
                } else if (cta.contentName == CMSTemplateNames.Web_HomePage + " 2" || cta.contentName == CMSTemplateNames.Mobile_HomePage +" 2") {
                  this.homePageResponseCta= cta.contentStructure.recordList;
                }
                else if (cta.contentName == CMSTemplateNames.Web_HomePage + " 3" || cta.contentName == CMSTemplateNames.Mobile_HomePage +" 3")
                   { this.staticBottomContent = cta.contentStructure.recordList; }
                
              });
              if (this.pwdStatus === 'expiring') {
                    this.pwdExpiring = true;
                  }           
            }
    });
  }
  downloadFullProductCatalog() {
    this.isDownloadProduct = true;
  }
  onProductChange($event) {
    this.selectedRole=$event.target.value;
    localStorage.setItem("productRadioKey", $event.target.value);
    if ($event.target.value == "Current Customer") {
      this.showCurrentCustomer = true;
      this.searchBarDisabled = true;
      this.isHidden = false;
      this.downloadCatalog = false;
    }
    else {
      this.showCurrentCustomer = false;
      this.downloadCatalog = true;
    }
    this.resetCatalogFilterBy();
    this.productsHideOrShow = false;
    this.searchBarDisabled = false;
    if (this.appConfig.gTrackingId) {
      this.gAnalytics.logTypeOfCustomer($event.target.value);
    }
  }
  resetCatalogFilterBy() {
    this.catalogFilterBy = null;
  }
 
  
  private getProductCatalogsForShop() {
    this.staticContentService.getProductCatalog().subscribe((res: any) => {
      if (!res.hasError) {
        this.productCatlogs.show = true;
        this.productCatlogs.catalogs = res;
        this.productCatlogs.catalogs.forEach((catalog) => {
          if (catalog.label == "Recently Launched Generics") {
            AppUtilService.cache.set(
              CacheConstant.Catalog_Data,
              catalog,
              CacheDuration.OneHour
            );
            AppUtilService.router.navigate([ProductRoutes.ProductCatalog]);
          }
        })
      }
    });
  }
  getCmsContent() {
    this.cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.templateNum = this.envProperties.cmsPageConfigVO.carouselTemplateId;
    this.cmsService.getCmsContentByPageNameAndTemplateNum(this.cmsPageName, this.buId, this.templateNum).subscribe((response: any) => {
      if (!response.hasError) {
        let carouselImages = response;
        this.carousel = this.cmsService.prepareCarouselImages(
          carouselImages
        );
        setTimeout(() =>{
          this.cmsSlides = document.getElementsByClassName("cmsSlides") as HTMLCollectionOf<HTMLElement>;
            this.cmsDots = document.getElementsByClassName("cmsDots") as HTMLCollectionOf<HTMLElement>;
          this.showCmsCarouselSlides();
       }, 50); 
      }
    });
  }
  getCTAContent() {
    this.ctaPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    this.ctaTemplateNum = this.envProperties.cmsPageConfigVO.ctaTemplateId;
    console.log(this.ctaTemplateNum)
    this.cmsService.getCmsContentByPageNameAndTemplateNum(this.ctaPageName, this.buId, this.ctaTemplateNum).subscribe((response: any) => {
      if (!response.hasError) {
        if (response.length > 0) {
          this.callToActionArrays = response;
          this.contentArr = []
          
            const sortedAndGroupesCallToActions = _.chain(this.callToActionArrays)
              .orderBy((callToActonObj: CmsContent) => callToActonObj.rowUpdateStamp, ['desc'])
              .groupBy((callToActonObj: CmsContent) => callToActonObj.sequenceNum)
              .value();
            for (const key of Object.keys(sortedAndGroupesCallToActions)) {
              this.contentArr.push(sortedAndGroupesCallToActions[key][0]);
            }
            this.contentArr = this.parseContentStructureField(this.contentArr);
            console.log(this.contentArr)
        }
      } 
    });
    
  }
  private parseContentStructureField(
    callToActionDataArray: CmsContent[]
  ): CmsContent[] {
    if (callToActionDataArray.length > 0) {
      callToActionDataArray = _.orderBy(
        callToActionDataArray,
        [CmsContentField.sequenceNum],
        'asc'
      );
      callToActionDataArray.forEach((cta: CmsContent) => {
        cta.contentStructureJson = JSON.parse(cta.contentStructure);
        cta.contentStructureJson.description = this.sanitizer.bypassSecurityTrustHtml(this.cmsService.processHtmlContentforHashTag(cta.contentStructureJson.description));
        cta.increaseImageHeight =
        cta.contentStructureJson.description !== '' ? false : true;
      });
      return callToActionDataArray;
    }
  }

  renderHtmlContent() {
    this.renderer.listen(this.elementRef.nativeElement, 'click', (event) => {
      if (event.target instanceof HTMLAnchorElement) {
        this.hyperLinkID = event.target.id
        if (this.hyperLinkID.startsWith('hyperlink-')) {
          this.hyperLinkID = this.hyperLinkID.replace('hyperlink-', '');
          this.hyperLinkID = this.hyperLinkID.replace('"', '');
          if (this.hyperLinkID) {
            this.cmsService.downloadDocumentFromHashTagNum(this.hyperLinkID);
          }
        }
      }
    });
  }
  
  showCmsCarouselSlides(n = -1){
    if (n === -1 && this.slideClick) {
      this.slideClick = false;
      return;
    }

    for (let i = 0; i < this.cmsSlides.length; i++) {
      this.cmsSlides[i].style.display = "none";
      this.cmsDots[i].className = this.cmsDots[i].className.replace(" active", "");
    }
    if (n > -1) {
      this.cmsSlideIndex = n;
    }
    this.cmsSlideIndex++;
    if (this.cmsSlideIndex > this.cmsSlides.length) {
      this.cmsSlideIndex = 1
    }
   if(this.cmsSlides.length>0){
    this.cmsSlides[this.cmsSlideIndex-1].style.display = "block";
    this.cmsDots[this.cmsSlideIndex-1].className += " active";
   }
   
    this.timeOutIDs.push(
    setTimeout(() => this.showCmsCarouselSlides(), this.carousel.rotationalDelay * 1000)
    );
  }

  navigateToTargetLink(cmsContentLinkObj: any) {
    if (!_.isEmpty(cmsContentLinkObj)) {
      this.cmsService.redirectBasedOnLinkType(cmsContentLinkObj);
    }
  }
  navigateUrl(cmsContentLinkObj:any){
  if (!_.isEmpty(cmsContentLinkObj)) {
      window.open(cmsContentLinkObj.targetlink, '_self');
    }
  }

  onCarouselClick(carouselData: any){
    this.cmsService.redirectBasedOnLinkType(carouselData);
  }

  cmsCurrentSlide(i){
    this.slideClick = true;
    this.showCmsCarouselSlides(i);
  }

  private openSalePopupDialog(): void {
    if (this.homePageSalePopup && this.onSaleItems.length > 0) {
      const dialogRef = this.dialog.open(SalePopupComponent, {
        width: '870px',
        data: {
          cmsContent: this.homePageSalePopup,
          itemList: this.onSaleItems
        },
        disableClose: true
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result === 'close') {
          if (this.homePageGenericPopup) {
            this.openGenericPopup();
          }
          else
            this.cmsService.isFromFeaturedItems.next(false);
        }
      });
    } else if (this.homePageGenericPopup) {
      this.openGenericPopup();
    } else if (this.homePageAdPopups) {
      this.openAdPopupDialog();
    }
  }
   scrollProduct(id){
  if(!this.isDesktopDevice()){
  this.scroll.scrollToAnchor(id);
  }
  }
}
